import React, { ReactNode, useEffect, useState } from "react";
import { useAppDispatch as useDispatch } from "src/core/redux/hooks";
import {
    Button,
    Form,
    FormField,
    Input,
    Link,
    Select,
    SpaceBetween,
} from "@cloudscape-design/components";
import {
    setPageTitle,
    appendBreadCrumb,
    appendInfoMessage,
    selectOnboardingRequest,
    removeInfoMessage,
    resetOnboardingRequest,
    setHelpPanelOpen,
} from "src/core/redux";
import { SentinelPageProps } from "../../interfaces";
import { SentinelBasePage } from "../sentinel-base";
import { submitOnboardingRequest } from "src/core/sentinel/actions";
import { SentinelController } from "src/core/controller";
import { useSelector } from "react-redux";
import { SentinelLoadingStatus } from "src/core/sentinel/types";
import { useInfoSection } from "../../components/SentinelLayout/index";
import { SentinelTeamEmailInfoSection } from "./help/team-email-info";
import { SentinelDefaultInfoSection } from "src/web/components/SentinelLayout/help/default-info-section";
export interface SentinelOnboardingPageProps extends SentinelPageProps {
    readOnly?: boolean;
    sentinelController: SentinelController;
}
export const OnboardingPage: React.FC<SentinelOnboardingPageProps> = (
    props: SentinelOnboardingPageProps
) => {
    const [, setInfoSection,,setToolsOpen] = useInfoSection();
    const [alias, setAlias] = useState("");
    const [teamName, setTeamName] = useState("");
    const [teamEmail, setTeamEmail] = useState("");
    const [submitButtonLabel, setSubmitButtonLabel] = useState("Submit Request");
    const onboardingRequest = useSelector(selectOnboardingRequest);
    const status = onboardingRequest?.status;
    // Set page title
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle("Onboarding Page"));
        dispatch(appendBreadCrumb({ text: "Onboarding", href: "/onboard" },));
    }, []);

    // Set initial state
    useEffect(() => {
       setAlias(props.sentinelController.userIdentity.username);
    }, [props.sentinelController.userIdentity.username]);

    useEffect(() => {
        setAlias(props.sentinelController.userIdentity.username);
     }, [props.sentinelController.userIdentity.username]);

    useEffect(() => {
        return () => {
          setToolsOpen(false);
          setInfoSection(<SentinelDefaultInfoSection />);
        };
      }, []);
    useEffect(() => {
        dispatch(removeInfoMessage({ id: 'message_1' }));
    }, []);
    
    useEffect(() => {
        if (status === SentinelLoadingStatus.FINISHED) {
            dispatch(removeInfoMessage({ id: 'message_onboardingrequest_submit' }));
            dispatch(appendInfoMessage({
                type: 'success',
                dismissible: true,
                content: "Request submitted",
                dismissLabel: 'development',
                id: 'message_onboardingrequest_success',
            }));
        } else if (status === SentinelLoadingStatus.REJECTED) {
            dispatch(removeInfoMessage({ id: 'message_onboardingrequest_submit' }));
            dispatch(appendInfoMessage({
                type: 'error',
                dismissible: true,
                content: "Request submitted failed",
                dismissLabel: 'development',
                id: 'message_onboardingrequest_error',
            }));
        }
    }, [status]);

    //Input Validation
    const isFormValid = teamName !== "";
    //Function to handle form submission
    const handleSubmit = async () => {
        const payload = {
          requesterId: alias,
          pipelineNames: [],
          teamName: teamName,
          teamEmail: teamEmail,
        };
        console.log('Submit onboarding request:', JSON.stringify(payload, null, 2));
        // Reset form
        setTeamName('');
        setTeamEmail('');
        dispatch(appendInfoMessage({
            type: 'info',
            loading: true,
            content: 'Request submitted successfully, waiting for response',
            dismissLabel: 'development',
            id: 'message_onboardingrequest_submit',
        }));
        try {
            const response = await dispatch(
              submitOnboardingRequest({
                sentinelController: props.sentinelController,
                onboardingRequestInput: payload,
              })
            );  
          } catch (error) {
            dispatch(removeInfoMessage({ id: 'message_onboardingrequest_submit' }));
            dispatch(appendInfoMessage({
                type: 'error',
                dismissible: true,
                content: "Request submitted failed",
                dismissLabel: 'development',
                id: 'message_onboardingrequest_error',
            }));
            dispatch(resetOnboardingRequest())
            console.error(
              `Error for submitting onboard request: ${error}`,
              error,
            );
          }
      };


      const loadHelpPanelContent = (content: ReactNode) => {
        setToolsOpen(true);
        setInfoSection(content);
      };

    return (
        <SentinelBasePage header="Get Started">
            <Form
                actions={
                    <SpaceBetween direction="vertical" size="s">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button
                                variant="primary"
                                disabled={!isFormValid}
                                onClick={() => handleSubmit()}
                            >
                                {submitButtonLabel}
                            </Button>
                        </SpaceBetween>
                    </SpaceBetween>
                }
            >
                <FormField>
                    <div className="formfield-margin">
                        <strong>Requester:</strong> {alias}
                    </div>
                </FormField>

                <FormField>
                    <div className="formfield-margin">
                        <strong>Team Name</strong>
                        <Input
                            type="text"
                            placeholder="Please enter team name"
                            value={teamName}
                            onChange={(event) => setTeamName(event.detail.value)}
                        />
                    </div>
                </FormField>
            </Form>
        </SentinelBasePage>
    );
};